var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19.256,
    viewBox: "0 0 19 19.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "person_FILL1_wght600_GRAD0_opsz48",
    d: "M16.786,16.494a4.474,4.474,0,0,1-4.658-4.658A4.476,4.476,0,0,1,16.786,7.15a4.5,4.5,0,0,1,4.686,4.686,4.511,4.511,0,0,1-1.321,3.351A4.585,4.585,0,0,1,16.786,16.494ZM7.3,26.406v-3.1a3.492,3.492,0,0,1,.6-2.031,3.853,3.853,0,0,1,1.562-1.321,20.39,20.39,0,0,1,3.721-1.306,15.521,15.521,0,0,1,3.607-.426,14.988,14.988,0,0,1,3.621.44,21.97,21.97,0,0,1,3.678,1.292,3.711,3.711,0,0,1,1.6,1.292A3.482,3.482,0,0,1,26.3,23.31v3.1Z",
    transform: "translate(-7.3 -7.15)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUser);
export default __webpack_public_path__ + "static/media/header_user.34d39b70c901142ac15f67706c17fe46.svg";
export { ForwardRef as ReactComponent };